<template>
  <div class="mb-1" v-if="detail.value != null">
    <h5 class="mb-0 text-primary">{{ translate(detail.title) }}</h5>
    <div v-if="detail.type === 'array' || detail.type === 'target' || detail.type === 'detailable'" class="ps-2 border-left border-secondary">
      <AuditLogDetailArray :details="detail.value"/>
    </div>
    <div v-else-if="detail.type === 'id'" class="small">
      <i class="fas fa-hashtag me-0 text-muted"></i> {{ detail.value }}
    </div>
    <div v-else-if="detail.type === 'color'">
      <i class="fas fa-circle me-0" style="font-size: 0.75em" :style="{ color: detail.value }"></i> <span class="small">{{ detail.value }}</span>
    </div>
    <div v-else-if="detail.type === 'boolean'">
      <i class="fas me-0" :class="detail.value ? 'fa-circle-check text-success' : 'fa-circle-xmark text-warning'" style="font-size: 0.75em" :style="{ color: detail.value }"></i> <span class="small">{{ detail.value ? translate("yes") : translate("no") }}</span>
    </div>
    <span v-else class="small">{{ valueText ?? "&nbsp;" }}</span>
  </div>
</template>

<script>
import {defineAsyncComponent} from "vue";
import {utilities} from "@niftybit/vue";
import localization from "@/localization";
const AuditLogDetailArray = defineAsyncComponent(() => import("@/systems/modules/auditLogs/AuditLogDetailArray.vue"));

export default {
  name: "AuditLogDetail",
  components: {AuditLogDetailArray},
  props: {
    detail: Object
  },
  computed: {
    valueText() {
      if (this.detail.value == null) return undefined;
      switch (this.detail.type) {
        case "text": return this.detail.value;
        case "id": return this.detail.value;
        case "boolean": return this.detail.value ? localization.translate("yes") : localization.translate("no");
        case "dateTime": return utilities.formatDatetime(this.detail.value);
        case "translation": return localization.translate(this.detail.value);
        case "duration": return utilities.formatDuration(this.detail.value);
      }
      return undefined;
    }
  }
}
</script>

<style scoped>

</style>